import { useLocation, useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../lib/auth-context';
import { isMarketingPublicPath } from './marketing/marketingStandaloneNav';

const HUB_PATHS = new Set([
  '/',
  '/early-access',
  '/launch',
  '/pricing',
  '/auth',
  '/auth/callback',
  '/onboarding',
  '/singles-onboarding',
  '/mode-selection',
  '/email-verified',
  '/waitlist-blitz',
]);

/**
 * Fixed top-left Back for marketing / logged-out flows.
 * Authenticated app routes use the inline Back control next to the menu in {@link Navigation} instead
 * (see `showAppBack` there) so we never stack two competing Back buttons.
 */
export function SiteBackNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const user = auth?.user ?? null;
  const p = location.pathname;

  if (p.startsWith('/admin') || p.startsWith('/marketing') || p.startsWith('/debug') || p.startsWith('/enterprise')) {
    return null;
  }

  if (HUB_PATHS.has(p)) {
    return null;
  }

  if (user && !isMarketingPublicPath(p)) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed left-3 top-3 z-[100] sm:left-4 sm:top-4">
      <Button
        type="button"
        variant="secondary"
        size="sm"
        className="pointer-events-auto gap-2 border border-slate-200 bg-white/98 text-neutral-900 shadow-[0_10px_24px_rgba(15,23,42,0.08)] backdrop-blur-[6px] hover:bg-slate-50"
        onClick={() => {
          navigate(-1);
        }}
      >
        <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
        Back
      </Button>
    </div>
  );
}
